import AccessibleText from '../AccessibleHighlightedText'

import { useSimulationResult } from './useSimulationResult'

const SalaryAndMonthsAmount = () => {
  const { salaryText, monthsWorkedText } = useSimulationResult()

  return (
    <>
      <AccessibleText {...salaryText} />
      <AccessibleText {...monthsWorkedText} />
    </>
  )
}

export default SalaryAndMonthsAmount
